import { pickBy } from "../../../../utils/pick-by";
import { getValidationWithDefaults } from "./getValidationWithDefaults";
import { getIsRequiredError } from "./getIsRequiredError";
export var getEmptyRequiredInputs = function getEmptyRequiredInputs(inputsValidation, inputsState) {
  return pickBy(inputsValidation, function (inputValidation, inputName) {
    var validation = getValidationWithDefaults(inputValidation);
    return getIsRequiredError(validation, inputsState[inputName]);
  });
};